import api, { unwrap } from './client';

export async function listMyOrders(params = {}) {
  return unwrap(await api.get('/vendor/orders', { params }));
}

export async function getMyOrder(id) {
  return unwrap(await api.get(`/vendor/orders/${id}`));
}

export async function updateOrderStatus(id, status, notes) {
  return unwrap(await api.put(`/vendor/orders/${id}/status`, { status, notes }));
}

export async function uploadReport(orderId, file, { remarks, status } = {}, onProgress) {
  const fd = new FormData();
  fd.append('file', file);
  if (remarks) fd.append('remarks', remarks);
  if (status) fd.append('status', status);

  const res = await api.post(`/vendor/orders/${orderId}/reports`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    }
  });
  return unwrap(res);
}

// === Clinic profile (Phase 4) ===

export async function getMyClinicProfile() {
  return unwrap(await api.get('/vendor/clinic-profile'));
}

export async function updateMyClinicProfile(payload) {
  return unwrap(await api.put('/vendor/clinic-profile', payload));
}

// === Booking settings + day-view calendar (client 2026-08-04) ===

export async function getBookingSettings() {
  return unwrap(await api.get('/vendor/booking-settings'));
}

export async function updateBookingSettings(payload) {
  return unwrap(await api.put('/vendor/booking-settings', payload));
}

// ymd = "YYYY-MM-DD"
export async function getDaySchedule(ymd) {
  return unwrap(await api.get('/vendor/day', { params: { date: ymd } }));
}

// startYmd/endYmd = "YYYY-MM-DD" (inclusive). Used by week + month views.
export async function getRangeSchedule(startYmd, endYmd) {
  return unwrap(await api.get('/vendor/range', { params: { start: startYmd, end: endYmd } }));
}

// kind = 'mmc' | 'apc' | 'moh_ckaps' | 'ssm' | 'premise' | 'doctor_nric'
//      | 'lcp' | 'nsr' | 'indemnity_insurance' | 'waste_disposal'
export async function uploadClinicDocument(kind, file, onProgress) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post(`/vendor/clinic-profile/documents/${kind}`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    }
  });
  return unwrap(res);
}

// Download the current file for a doc kind as a Blob so the JWT header
// is attached (a plain <a href> wouldn't send auth). Callers turn the
// blob into an object URL and open it in a new tab for preview.
export async function fetchMyClinicDocumentBlob(kind) {
  const res = await api.get(`/vendor/clinic-profile/documents/${kind}/file`, {
    responseType: 'blob',
  });
  return res.data;
}

// GET /vendor/onboarding-progress — drives the "Step X of 5" banner +
// guided-tour overlay on the clinic dashboard.
export async function getOnboardingProgress() {
  return unwrap(await api.get('/vendor/onboarding-progress'));
}
